module.exports = __webpack_public_path__ + "static/media/lightbulb.2ed984cd.svg";